import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Countdown } from '../../countdown/countdown';
import { MILLISECONDS } from '../../../common/utils/date';
import { buildUrl } from '../../../common/utils/url/build-url';
import { openPopup } from '../../../common/utils/open-popup';
import classnames from 'classnames';
import styles from './live-label.scss';
import LiveIcon from '../../../icons/compiled/components/LiveIcon';
import ScheduledBigIcon from '../../../icons/compiled/components/ScheduledBigIcon';
import ScheduledSmallIcon from '../../../icons/compiled/components/ScheduledSmallIcon';
import { InlineIcon } from '../../inline-icon/inline-icon';
const defaultDateFormat = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit'
};
const toShortISOWithoutDelimiters = datetime => new Date(datetime).toISOString().replace(/-|:|\.\d+/g, '');
export class ThumbnailLiveLabel extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "openGoogleCalendarEvent", event => {
      const {
        startTime,
        liveText,
        videoTitle
      } = this.props;
      const startTimeShortISO = toShortISOWithoutDelimiters(startTime);
      const url = buildUrl('https://www.google.com/calendar/event', {
        action: 'TEMPLATE',
        dates: `${startTimeShortISO}/${startTimeShortISO}`,
        text: videoTitle,
        location: '',
        details: liveText
      });
      openPopup(url);
      event.stopPropagation();
    });
  }
  renderLiveLabel() {
    const {
      liveText,
      pendingLiveText,
      isPendingLiveStream,
      className,
      isRTL
    } = this.props;
    const label = isPendingLiveStream ? pendingLiveText : liveText;
    const liveStreamLabelClassNames = classnames(styles.live, className, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const liveIconClassNames = classnames(styles['live-icon'], {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const liveTextClassNames = classnames(styles['live-text'], {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "live-stream-label",
      className: liveStreamLabelClassNames,
      role: "note",
      "aria-label": label
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(LiveIcon, null),
      className: liveIconClassNames
    }), /*#__PURE__*/React.createElement("span", {
      className: liveTextClassNames
    }, label));
  }
  renderScheduledLabel() {
    const {
      className,
      liveText,
      addReminderText,
      reminderAriaLabel,
      thumbnailWidth,
      isFocusable,
      isRTL
    } = this.props;
    const ScheduledIcon = thumbnailWidth < 500 ? ScheduledSmallIcon : ScheduledBigIcon;
    const scheduledLabelClassNames = classnames(styles.scheduled, className, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const scheduledIconClassNames = classnames(styles['scheduled-icon'], {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const scheduledTextClassNames = classnames(styles['scheduled-text'], {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const reminderClassNames = classnames(styles.reminder, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": "scheduled-label",
      className: scheduledLabelClassNames,
      "aria-label": this.getScheduledAriaLabel(),
      role: "region",
      tabIndex: isFocusable ? 0 : -1
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(ScheduledIcon, null),
      className: scheduledIconClassNames
    }), /*#__PURE__*/React.createElement("span", {
      className: scheduledTextClassNames
    }, `${liveText}: `, this.renderScheduledTime()), /*#__PURE__*/React.createElement("span", {
      onClick: this.openGoogleCalendarEvent,
      tabIndex: isFocusable ? 0 : -1,
      role: "link",
      className: reminderClassNames,
      "aria-label": reminderAriaLabel
    }, addReminderText));
  }
  getScheduledAriaLabel() {
    const {
      startTime,
      scheduledSoonAriaLabel,
      scheduledAriaLabel
    } = this.props;
    return startTime - Date.now() < MILLISECONDS.ONE_DAY ? scheduledSoonAriaLabel : scheduledAriaLabel;
  }
  renderScheduledTime() {
    const {
      startTime,
      startsInAriaLabel,
      locale,
      dateFormat,
      isFocusable
    } = this.props;
    if (startTime - Date.now() > MILLISECONDS.ONE_DAY) {
      return new Date(startTime).toLocaleString(locale, dateFormat);
    }
    return /*#__PURE__*/React.createElement(Countdown, {
      until: startTime,
      titlePrefix: startsInAriaLabel,
      isFocusable: isFocusable
    });
  }
  render() {
    const {
      isStreaming,
      isScheduled
    } = this.props;
    if (isStreaming) {
      return this.renderLiveLabel();
    }
    if (isScheduled) {
      return this.renderScheduledLabel();
    }
    return null;
  }
}
_defineProperty(ThumbnailLiveLabel, "defaultProps", {
  dateFormat: defaultDateFormat
});
//# sourceMappingURL=live-label.js.map